export interface EngineTone {
  frequency: number
  gain: number
}

export interface EngineSampleMix {
  lowGain: number
  highGain: number
  boostGain: number
  exhaustGain: number
  driftGain: number
  lowRate: number
  highRate: number
  driftRate: number
}

function clampUnit(value: number): number {
  return Math.min(1, Math.max(0, value))
}

function smoothstep(value: number): number {
  return value * value * (3 - 2 * value)
}

export function getEngineTone(speed: number): EngineTone {
  const normalized = clampUnit(Math.abs(speed) / 72)
  return {
    frequency: Number((58 + normalized * 90).toFixed(3)),
    gain: Number((0.035 + normalized * 0.085).toFixed(3)),
  }
}

export function getEngineSampleMix(speed: number, boosting: boolean, drifting = false): EngineSampleMix {
  const normalized = clampUnit(Math.abs(speed) / 72)
  const blend = smoothstep(normalized)
  const roadLoad = smoothstep(clampUnit((normalized - 0.1) / 0.9))
  const driftActive = drifting && normalized >= 0.08
  return {
    lowGain: Number((0.34 * (1 - blend * 0.82)).toFixed(3)),
    highGain: Number((0.34 * blend).toFixed(3)),
    boostGain: boosting ? 0.23 : 0,
    exhaustGain: Number((roadLoad * 0.2 + (boosting ? 0.04 : 0)).toFixed(3)),
    driftGain: driftActive ? Number((0.12 + normalized * 0.18).toFixed(3)) : 0,
    lowRate: Number((0.82 + normalized * 0.38).toFixed(3)),
    highRate: Number((0.78 + normalized * 0.36).toFixed(3)),
    driftRate: Number((0.88 + normalized * 0.18).toFixed(3)),
  }
}
